import { render, staticRenderFns } from "./newNsiaEtude.vue?vue&type=template&id=76b7cb5a&scoped=true"
import script from "./newNsiaEtude.vue?vue&type=script&lang=js"
export * from "./newNsiaEtude.vue?vue&type=script&lang=js"
import style0 from "./newNsiaEtude.vue?vue&type=style&index=0&id=76b7cb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7cb5a",
  null
  
)

export default component.exports